const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/ncr-form-elements`,
    saveCostsTable: `${API_URL}/ncr-form-element/save-costs-table`,
    saveDiscountTable: `${API_URL}/ncr-form-element/save-discount-table`
};

export default apiUrls;
